import { useState, useEffect } from "react";
import basketStream from ".";
export default function useBasket(_a) {
    var _b = _a === void 0 ? {} : _a, onError = _b.onError, onComplete = _b.onComplete;
    var _c = useState({
        items: basketStream.items,
        paymentProvider: basketStream.paymentProvider,
        breakdown: basketStream.breakdown,
        isLoading: false
    }), basket = _c[0], setBasket = _c[1];
    useEffect(function () {
        var subscription = basketStream.subscribe(function (_a) {
            var items = _a.items, breakdown = _a.breakdown, isLoading = _a.isLoading;
            setBasket({
                paymentProvider: basketStream.paymentProvider,
                items: items,
                breakdown: breakdown,
                isLoading: isLoading
            });
        }, onError, onComplete);
        return function () {
            return subscription.unsubscribe();
        };
    }, []);
    return basket;
}
